import House from '../src/House';
export default House;
